import React from 'react';
import bentleyLogo from '../../../assets/bentley-green-logo.png';
import { defaultFont } from '../../../styles/SharedStyles';

export const LoginIntroduction = () => (
  <div
    style={{
      ...defaultFont,
      padding: '0px 30px',
      lineHeight: '1.4',
      textAlign: 'left',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <img src={bentleyLogo} />
    <p style={{ width: '490px' }}>
      Use{' '}
      <a
        target='_new'
        href='https://www.bentley.com/en/products/brands/projectwise'
      >
        ProjectWise 365 Services
      </a>{' '}
      to save time, eliminate risk, and improve project performance by
      automating supply chain workflows and managing information exchanges
      within your digital project environment.
    </p>
  </div>
);
